import { Request } from '@group-devs/yfp7-global-modules'
import { Footer } from '@group-devs/yfp7-global-modules/components/Block'
//import { Footer } from '../../backup/components/Block'
import { useRouter } from 'next/router'
import {useEffect} from 'react'
import { WellnessTopNav, WellnessFooterNav } from '@components/Block'
import Head from 'next/head'
import ReactGA from 'react-ga';
import { stripTags } from '@group-devs/yfp7-global-modules/utils/general'

const request = new Request(process.env.apiDomain)

const OG_IMAGE_WIDTH = 1200
const OG_IMAGE_HEIGHT = 628

const getImageMimeType = (imageUrl) => {
    const path = imageUrl ? imageUrl.split('?')[0].toLowerCase() : ''

    if (path.endsWith('.png')) return 'image/png'
    if (path.endsWith('.webp')) return 'image/webp'
    if (path.endsWith('.gif')) return 'image/gif'
    if (path.endsWith('.jpg') || path.endsWith('.jpeg')) return 'image/jpeg'

    return ''
}

function Layout(props) {
    
    const router = useRouter()
    const auth = props.global.auth
    const site = props.global.site
    const { data: hub } = request.website.swrSite(site.accountId, "HUB")
    const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
    const { data: tracker } = request.insights.swrTracking(site.id)

    useEffect(()=>{
        if (tracker)
        {
            try {
                if (tracker.ga_id)
                {
                    ReactGA.initialize(tracker.ga_id);
                    ReactGA.pageview(window.location.pathname + window.location.search);
                }
                if (tracker.matomo_id && tracker.matomoServer)
                {
                    var _paq = window._paq = window._paq || [];
                    _paq.push(['trackPageView']);
                    _paq.push(['enableLinkTracking']);
                    (function() {
                        var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
                        _paq.push(['setTrackerUrl', u+'/matomo.php']);
                        _paq.push(['setSiteId', tracker.matomo_id]);
                        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                        g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
                    })();
                }
            } catch (error) {
                console.error("Tracker Error:", error);
            }
        }
    }, [tracker])
  
  
    const pageTitle = props && props.article && props.article.title ? props.article.title : site.name + " - Wellness Center";
    const title = props && props.article && props.article.title ? props.article.title : '';
    const theExcerpt = props && props.article && props.article.theExcerpt ? props.article.theExcerpt : '';
    const description = theExcerpt ? stripTags(theExcerpt) : ''
    const defaultImage = "https://" + site.url + "/images/img-share02.jpg"
    const image = props && props.article && props.article.featureImg ? props.article.featureImg : defaultImage;
    const imageType = getImageMimeType(image)
    const imageAlt = title || pageTitle

    return (
        <div className="page-layout wellnessCenter">
            <Head>
    <title>{pageTitle}</title>
    <meta property="og:url" content={"https://" + site.url + router.asPath} />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content={site.name} />
    <meta property="og:title" content={title} />
    
    {description ?
    <>
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
        <meta name="twitter:description" content={description} />
    </>
    : null}
    
    {image ?
    <>
        <meta property="og:image" content={image} />
        {image.startsWith('https://') ? <meta property="og:image:secure_url" content={image} /> : null}
        {imageType ? <meta property="og:image:type" content={imageType} /> : null}
        <meta property="og:image:width" content={OG_IMAGE_WIDTH} />
        <meta property="og:image:height" content={OG_IMAGE_HEIGHT} />
        <meta property="og:image:alt" content={imageAlt} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:image:alt" content={imageAlt} />
    </>
    : null}
    
    <meta name="author" content={site.name} />
    
    {/* Font loading - load during both SSR and client-side */}
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
    <link 
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" 
        rel="stylesheet" 
        crossOrigin=""
    />
</Head>
            
            <WellnessTopNav site={site} auth={auth} searchItems={props.searchItems}/>
            {props.children}
            {nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} origin="wellness"/> : null}
            <WellnessFooterNav auth={props.global.auth} site={site} />

            <style jsx global>{`
    body{
        font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
        color:#000;
    }

    .dropdown-item{
        color:#232323;
        padding: .25rem 1rem;
    }

    .myStrip__media{
        border: 2px solid;
    }

    .myStrip__media svg {
        position: relative;
        top: -2px;
    }

    .footer__menuLinks{
        border-color: #ecca28!important;
    }
`}</style>
        </div>
    )
}

export default Layout
